import { render, staticRenderFns } from "./SithMesPrdToolsPackageItemList.vue?vue&type=template&id=1838a956&"
import script from "./SithMesPrdToolsPackageItemList.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdToolsPackageItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports